export default {
    Agendado: 'Agendado',
    AgendadoProfissional: "Agendado com profissional",
    AgendadoProfissionalPreferencial: "Agendado preferencial",
    Confirmado: "Confirmado",
    Presente: "Presente",
    Executado: "Executado",
    Faltou: "Faltou",
    Bloqueio: "Bloqueio",
    ExecutadoPreVenda: "Executado Pré-Venda",
    ExecutadoPago: "Executado Pago"
}